export class TaxLoaderError extends Error {
    public readonly name: string;
    public readonly stack: string;

    constructor(message: string, stack: string = '') {
        super(message);
        this.name = 'TaxServiceFailed';
        this.stack = stack;
        Object.setPrototypeOf(this, TaxLoaderError.prototype);
    }
}
